import Text from '@ab-core/text';
import styled from 'styled-components';

export const StyledBold = styled(Text)`
    font-weight: bold;
`;
